import { DoorCardProps } from "./DoorCard.js";
import { DateTime } from "luxon";
import { DoorReservation } from "./index.js";
import { TOrder, TOrderRaw } from "../api.js";

const formatContactPersonOrOrderId = (
  orderObj: TOrder | TOrderRaw | null,
  tenantKey: string
): string => {
  if (!orderObj) {
    return "";
  }
  if (['tesla', 'tesla-dev'].includes(tenantKey)) {
    let userIdentifier = "contact-not-available"

    if ("order" in orderObj && orderObj.order?.raw?.authIdentifier) {
      userIdentifier = orderObj.order.raw.authIdentifier;
    }else if ("raw" in orderObj && orderObj.raw?.authIdentifier) {
      // required for All Orders view.
      userIdentifier = orderObj.raw.authIdentifier;
    }
    return userIdentifier;
  }

  if (tenantKey.includes("alstom")) {
    let userIdentifier = "externalId not available"

    if ("order" in orderObj && orderObj.order?.raw?.externalId) {
      userIdentifier = orderObj.order.raw.externalId;
    }else if ("raw" in orderObj && orderObj.raw?.externalId) {
      // required for All Orders view.
      userIdentifier = orderObj.raw.externalId;
    }
    return userIdentifier;
  }

  let result = "contact-not-available";
  let orderId = "orderId-not-available";

  if ("tikiOrder" in orderObj && orderObj.tikiOrder.source === "Regiondo") {
    result = `${orderObj.regiondoOrder?.contact_data?.firstname} ${orderObj.regiondoOrder?.contact_data?.lastname}`;
    orderId = orderObj.regiondoOrder?.order_id;
  } else {
    const rawOrder = "raw" in orderObj ? orderObj.raw : orderObj.order?.raw;
    if (rawOrder) {
      result = rawOrder.customer?.username ?? rawOrder.customer?.email;
      orderId = rawOrder.orderID;
    }
  }
  return result ? result : orderId;
};

const filterFirstLevelResourceTypes = (props: DoorCardProps): string[] => {
  let firstLevelTypes = props.doorResourceTypes;

  if (props.doorResourceTypes?.filter((str) => str.includes(":")).length > 0) {
    firstLevelTypes = props.doorResourceTypes.filter((str) =>
      str.includes(":"),
    );
  }
  return firstLevelTypes;
};

const filterNormalResourceTypes = (props: DoorCardProps): string[] => {
  let normalTypes = props.doorResourceTypes;

  if (props.doorResourceTypes?.filter((str) => str.includes(":")).length > 0) {
    normalTypes = props.doorResourceTypes.filter((str) => !str.includes(":"));
  }

  return normalTypes;
};

const formatDateTimeFromReservation = (
  reservation?: DoorReservation | null,
): string => {
  if (!reservation) {
    return "";
  }
  return dateTimeFormatter(reservation.createdAt, reservation.expiredAt);
};

const dateTimeFormatter = (startDate: number, endDate: number) => {
  const createdAt = DateTime.fromMillis(startDate);
  const expiredAt = DateTime.fromMillis(endDate);
  const today = DateTime.now().toISODate();

  const start =
    createdAt.toISODate() === today
      ? createdAt.toFormat("H:mm")
      : createdAt.toFormat("dd.M, H:mm");
  const end =
    expiredAt.toISODate() === today
      ? expiredAt.toFormat("H:mm")
      : expiredAt.toFormat("dd.M, H:mm");
  return `${start} - ${end}`;
};

export {
  formatContactPersonOrOrderId,
  filterFirstLevelResourceTypes,
  filterNormalResourceTypes,
  formatDateTimeFromReservation,
  dateTimeFormatter,
};
